"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var asg_1 = require("@alinta-digital/asg");
var ContentHeader_1 = (0, tslib_1.__importDefault)(require("./ContentHeader/"));
var ContentFooter_1 = (0, tslib_1.__importDefault)(require("./ContentFooter"));
var Content = function (props) {
    //TODO: check with Jake about padding for mobile being not part of ASG
    var children = props.children, header = props.header, footer = props.footer;
    var hideHeader = header.hide, restHeader = (0, tslib_1.__rest)(header, ["hide"]);
    var hideFooter = footer.hide, restFooter = (0, tslib_1.__rest)(footer, ["hide"]);
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !hideHeader && react_1.default.createElement(ContentHeader_1.default, (0, tslib_1.__assign)({}, restHeader)),
        react_1.default.createElement(asg_1.Box, { background: "#ffffff", round: "12px", "data-testid": "content" },
            react_1.default.createElement(asg_1.Box, { pad: {
                    top: 'large',
                    bottom: 'large',
                    horizontal: responsiveSize === 'xs' || responsiveSize === 'sm' ? 'medium' : 'large'
                } },
                react_1.default.createElement(asg_1.Box, { width: "100%", maxWidth: "720px !important", margin: "0 auto", "data-testid": "content-inner" }, children)),
            !hideFooter && react_1.default.createElement(ContentFooter_1.default, (0, tslib_1.__assign)({}, restFooter)))));
};
exports.default = Content;
//# sourceMappingURL=Content.js.map